import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  html,
  body {
    padding: 0;
    margin: 0;
    font-size: 14px;
    background: ${({ theme }: any) => theme.colors.body.default};
    color: ${({ theme }: any) => theme.colors.body.text};
    transition: all 0.50s linear;
    font-family: 'Roboto', sans-serif;
   
    line-height: 1.5;
  }

  html {
    font-size: 14px;
  }

  * {
    box-sizing: border-box;
  }
  a {
    text-decoration: none;
    color: ${({ theme }: any) => theme.colors.body.text};
  }
  .cursor-pointer {
    cursor: pointer;
  }

#nprogress {
  pointer-events: none;
}

#nprogress .bar {
  background: ${({ theme }: any) => theme.colors.primary.main};

  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;

  width: 100%;
  height: 3px;
  border-radius: 0px 4px 4px 0px;
  overflow: hidden;
}

/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px ${({ theme }: any) =>
    theme.colors.primary.main}, 0 0 5px ${({ theme }: any) =>
  theme.colors.primary.main};
  opacity: 1.0;

  -webkit-transform: rotate(3deg) translate(0px, -4px);
      -ms-transform: rotate(3deg) translate(0px, -4px);
          transform: rotate(3deg) translate(0px, -4px);
}

/* Remove these to get rid of the spinner */
#nprogress .spinner {
  display: block;
  position: fixed;
  z-index: 1031;
  top: 15px;
  right: 15px;
}

#nprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;

  border: solid 2px transparent;
  border-top-color: ${({ theme }: any) => theme.colors.primary.main};
  border-left-color: ${({ theme }: any) => theme.colors.primary.main};
  border-radius: 50%;

  -webkit-animation: nprogress-spinner 400ms linear infinite;
          animation: nprogress-spinner 400ms linear infinite;
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative;
}

.nprogress-custom-parent #nprogress .spinner,
.nprogress-custom-parent #nprogress .bar {
  position: absolute;
}

@-webkit-keyframes nprogress-spinner {
  0%   { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes nprogress-spinner {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.news-link{
  color: white;
}
.d-block{
  display: block;
}
.video-area{
  position: fixed;
  z-index: -1;
  top: 0;
  right:0;
  left:0;
  bottom:0;
  overflow: hidden;
}
.video-wrap {
  
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  width: 177.77777778vh; /* 16:9 の幅→16 ÷ 9＝ 177.77% */
  height: 56.25vw; /* 16:9の幅 → 9 ÷ 16 = 56.25% */
  min-height: 100%;
  min-width: 100%;
}


.animate {  
  animation-duration: 0.75s; //running slower to show effect
  animation-delay: 0.5s;
  animation-name: animate-fade;
  animation-timing-function: cubic-bezier(.26,.53,.74,1.48);
  animation-fill-mode: backwards;
  &.flip{
    animation-name: animate-flip;
    transform-style: preserve-3d;
    perspective: 1000px;
  }
  &.pop{
    animation-name: animate-pop;
  }
}


.modal-prizes {
  position: relative;
  z-index: 9999;
  .ReactModal__Content {
    inset: 0!important;
  }
}

/* Fade In */
@keyframes animate-fade {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

/* flip */
@keyframes animate-flip {
  0% {
  opacity: 0;
  transform: rotateX(-120deg) scale(0.9,0.9);
  }
  100% {
      opacity: 1;
      transform: rotateX(0deg) scale(1,1);
  }
  }

  /* pop */
  @keyframes animate-pop {
    0% {
      opacity: 0;
      transform: scale(0.2, 0.2);
    }
    100% {
      opacity: 1;
      transform: scale(1, 1);
    }
  }

  
`;
